export default __webpack_public_path__ + "static/media/property_367.c17ecbbd.png";